import { Component, OnInit, Input } from '@angular/core';
import { ReportsEventService, ReportType } from './reports-event.service';

@Component({
    selector: 'app-reports',
    host: { 'data-testid': 'reports-page' },
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {
    constructor(private reportEvents: ReportsEventService) {}

    ngOnInit() {}

    public get showEnrollmentReport() {
        return this.reportEvents.selectedType === ReportType.Enrollment;
    }

    public get showCapacityReport() {
        return this.reportEvents.selectedType === ReportType.Capacity;
    }

    public get showTransactionReport() {
        return this.reportEvents.selectedType === ReportType.Transaction;
    }
}
